import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SalesTaxInvoiceParamsFormService {
	endpointBase = '/api/invoice';

	constructor(private readonly http: HttpClient) {}

	getSalesTaxDueInfo(dateStart: Date, dateEnd: Date): Observable<any> {
		return this.http.get(`${this.endpointBase}/sales-tax-due-invoice`, {
			params: { StartDate: dateStart.toISOString(), EndDate: dateEnd.toISOString() },
		});
	}

	createSalesTaxDueInvoice(dateStart: Date, dateEnd: Date): Observable<any> {
		return this.http.post(`${this.endpointBase}/sales-tax-due-invoice`, {
			startDate: dateStart.toISOString(),
			endDate: dateEnd.toISOString(),
		});
	}
}
